module.exports = __webpack_public_path__ + "static/media/close.a752d58c.svg";